<template>
    <div>
        <!-- 打赏动态内容 开始 -->
        <div class="dashang-body">
            <div class="hide_box"></div>
            <div class="shang_box">
                <a class="shang_close" @click="close()" href="javascript:void(0)" title="关闭"><img src="static/images/dashang/close.png" alt="关闭" /></a>
                <div class="shang_tit">
                    <p>感谢您的支持，我们会继续努力的!</p>
                </div>
                <div class="shang_payimg">
                    <img src="static/images/dashang/alipayimg.png" alt="扫码支持" title="扫一扫" />
                </div>
                <div class="pay_explain">扫码赞助支持，你说多少就多少</div>
                <div class="shang_payselect">
                    <div :class="cur==0?'pay_item checked':'pay_item'" data-id="alipay" @click="change('alipayimg',0)">
                        <span class="radiobox"></span>
                        <span class="pay_logo"><img src="static/images/dashang/alipay.jpg" alt="支付宝" /></span>
                    </div>
                    <div :class="cur==1?'pay_item checked':'pay_item'" data-id="weipay" @click="change('weipayimg',1)">
                        <span class="radiobox"></span>
                        <span class="pay_logo"><img src="static/images/dashang/wechat.jpg" alt="微信" /></span>
                    </div>
                    <div :class="cur==2?'pay_item checked':'pay_item'" data-id="qqpay" @click="change('qqpayimg',2)">
                        <span class="radiobox"></span>
                        <span class="pay_logo"><img src="static/images/dashang/qq.jpg" alt="QQ" /></span>
                    </div>
                </div>
                <div class="shang_info">
                    <p>打开<span id="shang_pay_txt">支付宝</span>扫一扫，即可进行扫码赞助支持哦</p>
                    <p>分享从这里开始，精彩与您同在</p>
                    <p><a style="margin-right:20px;color:#009BE1;font-weight:bold;" href="https://www.paypal.me/sundad" target="_blank">
                            <font color="#01315F">PayPal</font> Donation
                        </a>
                        <router-link to="/support" target="_blank" style="color:blue;">查看赞助支持者列表</router-link>
                    </p>
                </div>
            </div>
        </div>
        <!-- 打赏动态内容 结束 -->
    </div>
</template>

<script>
    export default {
        name: 'Demo',
        components: {},
        data() {
            return {
                cur: 0
            }
        },
        created() {},
        mounted() {},
        methods: {
            change(dataid, e) {
                $(".shang_payimg img").attr("src", "static/images/dashang/" + dataid + ".png");

                this.cur = e
                if (e == 0) {
                    $("#shang_pay_txt").text("支付宝");
                } else if (e == 1) {
                    $("#shang_pay_txt").text("微信");
                } else {
                    $("#shang_pay_txt").text("QQ");
                }
            },
            close() {
                $(".hide_box").fadeOut();
                $(".shang_box").fadeOut();
            }

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Support.vue